import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, tryError } from "../lib/api";
import { getRecaptchaToken, preloadRecaptcha } from "../lib/recaptcha";
import RecaptchaNotice from "../components/RecaptchaNotice";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { CircleDot, Loader2, MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    preloadRecaptcha();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", {
        email: email.trim(),
        origin_url: window.location.origin,
        recaptcha_token: await getRecaptchaToken("forgot_password"),
      });
      setDone(true);
    } catch (err) {
      setError(tryError(err) || "Bir hata oluştu.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-foreground text-background flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-background text-foreground rounded-sm border border-border p-8" data-testid="forgot-page">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-10 w-10 rounded-sm bg-foreground flex items-center justify-center">
            <CircleDot className="h-6 w-6 text-amber-500" />
          </div>
          <div className="font-display font-black text-xl tracking-tighter">LASTİK OTELİ</div>
        </div>

        {done ? (
          <div className="space-y-4 text-center" data-testid="forgot-done">
            <div className="h-12 w-12 rounded-sm bg-amber-500 text-foreground flex items-center justify-center mx-auto">
              <MailCheck className="h-6 w-6" />
            </div>
            <h2 className="font-display font-black text-2xl tracking-tighter">Bağlantı gönderildi</h2>
            <p className="text-sm text-muted-foreground">
              Eğer bu e-posta sistemde kayıtlı ise, şifre sıfırlama bağlantısı gönderildi. Posta kutunuzu kontrol edin.
            </p>
            <Button asChild variant="outline" className="rounded-sm w-full">
              <Link to="/login"><ArrowLeft className="h-4 w-4 mr-1" /> Girişe Dön</Link>
            </Button>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4" data-testid="forgot-form">
            <div>
              <div className="label-eyebrow text-amber-600">Şifremi Unuttum</div>
              <h2 className="font-display font-black text-2xl tracking-tighter mt-1">Sıfırlama bağlantısı</h2>
              <p className="text-sm text-muted-foreground mt-2">
                E-posta adresinizi girin, sıfırlama bağlantısını gönderelim.
              </p>
            </div>
            <div className="space-y-1.5">
              <Label className="label-eyebrow">E-posta</Label>
              <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-sm h-11" data-testid="forgot-email" />
            </div>
            {error && <div className="border-l-2 border-destructive bg-destructive/10 px-4 py-3 text-sm text-destructive">{error}</div>}
            <Button type="submit" disabled={submitting} className="w-full h-12 rounded-sm bg-foreground text-background hover:bg-foreground/90" data-testid="forgot-submit">
              {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : "Bağlantıyı Gönder"}
            </Button>
            <Link to="/login" className="flex items-center justify-center gap-1 text-sm text-muted-foreground hover:text-foreground">
              <ArrowLeft className="h-3.5 w-3.5" /> Girişe Dön
            </Link>

            {/* Rozet gizlendiği için Google'ın istediği bilgilendirme metni */}
            <RecaptchaNotice className="text-center" />
          </form>
        )}
      </div>
    </div>
  );
}
